import { Tabs } from "routeConstants";
import { innerRoutes } from "routeUrls";

export default {
    [Tabs.REPORT_CLAIM]: innerRoutes[Tabs.REPORT_CLAIM],
    [Tabs.REPORT_CLAIM_OLD]: innerRoutes[Tabs.REPORT_CLAIM_OLD],
    [Tabs.CLAIMS_LIST]: innerRoutes[Tabs.CLAIMS_LIST],
};
